module.exports = __webpack_public_path__ + "img/VL_02_01.e77c5c45.png";